import ErrorBoundary from '@components/ErrorBoundary';
import AnalysisLanding from '@components/interview/Analysis/AnalysisLanding';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { Suspense } from 'react';

export default function InterviewThemes({ canEdit, analysisItemId } = {}) {
  return (
    <PageContainer title={'Interview | Themes'}>
      <ErrorBoundary>
        <Suspense fallback={<Spinner />}>
          <AnalysisLanding canEdit={canEdit} analysisItemId={analysisItemId} />
        </Suspense>
      </ErrorBoundary>
    </PageContainer>
  );
}
